function tabHeight() {
    const container = document.getElementById("tab-container");
    const tabs = container.querySelectorAll(".tab-content");

    // --- Tailwind min-h-[250px] entfernen ---
    container.classList.forEach(cls => {
        if (cls.startsWith("min-h-")) {
            container.classList.remove(cls);
        }
    });

    // --- Höhe des größten Tabs berechnen ---
    let maxHeight = 0;
    tabs.forEach(tab => {
        const wasHidden = tab.classList.contains("hidden");
        if (wasHidden) tab.classList.remove("hidden");

        const height = tab.scrollHeight;
        if (height > maxHeight) maxHeight = height;

        if (wasHidden) tab.classList.add("hidden");
    });

    // --- Inline min-height setzen ---
    container.style.minHeight = `${maxHeight}px`;

    console.log("Max Tab Height:", maxHeight + "px");
  }

  export { tabHeight };
